<script>
import Layout from "@layouts/form";
import Equipe from "@forms/Equipe";

export default {
  page: {
    title: "Detalhes | Equipe"
  },
  components: {
    Layout,
    Equipe
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Equipe",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Equipe",
          href: "/Equipe"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Equipe :editable="editable"></Equipe>
    </div>
  </Layout>
</template>
